<template>
  <div
    style="position: relative"
    class="user-item pa-1"
    :class="{
      'grey lighten-4':
        !(
          ['foodguru', 'cityfresh', 'summitcapital', 'tisco', 'seagull'].includes(
            $store.state.livechat.theme
          ) ||
          ['100207768987988'].includes($store.state.livechat.pageid) ||
          ['nt'].includes(selectedBot.type)
        ) && user.adminread == false,
      'grey lighten-3': selected,
      'red lighten-3': $aston.astonpages.includes($store.state.livechat.pageid) && !user.adminread,
      'brown lighten-3': ['foodguru'].includes($store.state.livechat.theme) && !user.adminread,
      'grey lighten-2':
        ['summitcapital', 'seagull'].includes($store.state.livechat.theme) && !user.adminread,
      'grey lighten-1': ['tisco'].includes($store.state.livechat.theme) && !user.adminread,
      'red lighten-3 white--text':
        ['100207768987988'].includes($store.state.livechat.pageid) && !user.adminreply,
      'red lighten-3':
        ['seagull'].includes($store.state.livechat.theme) &&
        $store.state.livechat.type === 'admin' &&
        checkOldCase(user.lastreply_time),
      'dark-style': ['cityfresh', 'tisco', 'seagull'].includes($store.state.livechat.theme)
    }"
    :style="customBackgroudStyle"
  >
    <v-layout row nowrap justify-space-between class="mb-0">
      <v-flex>
        <img
          v-if="user.is_block"
          style="width: 20px; height: auto"
          src="~@/assets/block.png"
          alt="block-icon"
        />
      </v-flex>
      <v-flex>
        <v-layout style="margin-bottom: 0" row justify-end>
          <v-menu offset-y :open-on-hover="true">
            <template #activator="{ on }">
              <v-icon style="font-size: 20px" v-on="on" @click.stop="clickUnPin">menu</v-icon>
            </template>

            <v-list>
              <v-list-tile :key="0" @click="handleMenuMarkUnRead">
                <v-list-tile-title>Mark as unread</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="user.is_block" :key="1" @click="handleMenuBlock(false)">
                <v-list-tile-title>UnBlock</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-else :key="2" @click="handleMenuBlock(true)">
                <v-list-tile-title>Block</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-icon
            v-if="pinUser.includes(user.userid)"
            style="font-size: 20px; color: #ff706b; transform: rotate(45deg)"
            @click.stop="clickUnPin"
            >push_pin</v-icon
          >
          <v-icon v-else style="font-size: 20px; transform: rotate(45deg)" @click.stop="clickPin"
            >push_pin</v-icon
          >
        </v-layout>
      </v-flex>
    </v-layout>
    <v-list-tile avatar class="px-0">
      <v-list-tile-avatar>
        <template v-if="user.profile_pic">
          <img class="profile" :src="user.profile_pic" alt @error="imgError(this)" />
        </template>
        <template v-else>
          <img class="profile" src="/static/img/assets/livechat/profile.png" alt />
        </template>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title
          v-if="
            [
              '103267601317473',
              '208321456497173',
              '103235014977289',
              ...$store.state.rabbitPage
            ].includes(selectedBot.pageid) ||
            isRatchthani ||
            isJuzmatch
          "
          :style="$vuetify.breakpoint.mdAndUp && `font-size: 13px`"
          :class="{ unreadmessage: !user.adminread }"
          >{{ userRealname }}</v-list-tile-title
        >
        <v-list-tile-title
          v-else-if="['cityfresh'].includes($store.state.livechat.theme)"
          :style="$vuetify.breakpoint.mdAndUp && `font-size: 13px`"
          :class="{ unreadmessage: !user.adminread }"
        >
          {{ `${user.first_name} ${user.last_name}${user.realname ? ` (${user.realname})` : ''}`
          }}{{ selectedBot.type == 'hopinnhr' && user.memberid ? `(${user.memberid})` : '' }}
        </v-list-tile-title>
        <v-list-tile-title
          v-else
          v-tooltip.left="`${user.first_name} ${user.last_name}`"
          :style="$vuetify.breakpoint.mdAndUp && `font-size: 13px`"
          :class="textColorClass"
        >
          <template v-if="user.realname">
            <span
              style="display: flex; align-content: center; align-items: center; flex-direction: row"
            >
              {{ user.realname }} <v-icon class="ml-2" small> info</v-icon>
            </span>
          </template>
          <template v-else>
            {{ `${user.first_name} ${user.last_name}` }}
          </template>
          {{ selectedBot.type == 'hopinnhr' && user.memberid ? `(${user.memberid})` : '' }}
        </v-list-tile-title>

        <!-- :class="{ unreadmessage: !user.adminread, `${textColorClass}`: ['nt'].inc }" -->

        <!-- Last message -->
        <!-- For AIS\Hippo -->

        <template
          v-if="
            (['foodguru'].includes($store.state.livechat.theme) ||
              ['100207768987988'].includes($store.state.livechat.pageid)) &&
            !user.adminread
          "
        >
          <v-list-tile-sub-title
            class="caption"
            :class="{
              unreadmessage: !user.adminread
            }"
          >
            {{ user.lastmessage | fmMessage }}
          </v-list-tile-sub-title>

          <v-list-tile-sub-title class="caption col-6" :class="{ unreadmessage: !user.adminread }">
            {{ dayLeft(user.lastreply_time) }}
          </v-list-tile-sub-title>
        </template>
        <template v-else>
          <v-list-tile-sub-title class="caption" :class="textColorClass">
            {{ user.lastmessage | fmMessage }}
          </v-list-tile-sub-title>

          <template v-if="['summitcapital'].includes($store.state.livechat.theme)">
            <v-list-tile-sub-title class="caption" :class="textColorClass">
              <v-layout wrap>
                <v-flex>
                  {{ dayLeft(user.lastreply_time) }}
                </v-flex>
                <v-flex class="text-xs-right">
                  {{ userLastReplyTime }}
                </v-flex>
              </v-layout>
            </v-list-tile-sub-title>
          </template>
          <template v-else>
            <v-list-tile-sub-title class="caption" :class="textColorClass">
              {{ dayLeft(user.lastreply_time) }}
            </v-list-tile-sub-title>
          </template>
        </template>
      </v-list-tile-content>
      <!-- <v-list-tile-action></v-list-tile-action> -->
    </v-list-tile>

    <div v-if="currentTheme == 'scgallrent'" class="text-xs-right">
      <v-chip v-if="user.status == 'Customer&Supplier'" small color="red" dark class="caption">{{
        user.status
      }}</v-chip>
      <v-chip v-else-if="user.status == 'Customer'" small color="blue" dark class="caption">{{
        user.status
      }}</v-chip>
      <v-chip v-else-if="user.status == 'Supplier'" small color="orange" dark class="caption">{{
        user.status
      }}</v-chip>
    </div>

    <div
      v-if="
        user.status &&
        ['148559413337', ...$store.state.oceanlifePage, ...page.DELTA].includes(selectedBot.pageid)
      "
      class="text-xs-right"
      :style="{
        'position: absolute; right: 0px; bottom: 0px': ['148559413337'].includes(selectedBot.pageid)
      }"
    >
      <v-chip small color="primary" dark class="caption">{{ user.status }}</v-chip>
    </div>

    <template v-if="selectedBot && selectedBot.unlock_ticket_3">
      <livechat-user-item-tags :user="user" />
      <livechat-user-item-ticket
        :user="user"
        @updateTicketStatus="handleUpdateTicketStatus"
      ></livechat-user-item-ticket>
    </template>
    <div v-if="isShowTicketInfo" class="text-xs-right mt-2">
      <v-chip small color="primary" dark class="caption">#{{ user.tickets[0][0] }}</v-chip>
      <v-chip
        small
        :color="ticketColorStatus(user.tickets[0][2])"
        dark
        class="caption"
        alt="Ticket Status"
        >{{ user.tickets[0][2] }}</v-chip
      >
    </div>

    <div
      v-if="
        ['ticket2', 'studio7', 'ustore', ...$store.state.ticketThemeList].includes(currentTheme) ||
        selectedBot.pageid == '100207768987988' ||
        [...$store.state.ticketPageid, ...$store.state.oceanlifePage].includes(selectedBot.pageid)
      "
    >
      <div
        v-if="
          (selectedBot.pageid == '100207768987988' &&
            user.tickets &&
            user.tickets.length > 0 &&
            user.hasOwnProperty('tickets')) ||
          ((['ticket2', 'studio7', 'ustore', ...$store.state.ticketThemeList].includes(
            currentTheme
          ) ||
            [...$store.state.ticketPageid, ...$store.state.oceanlifePage].includes(
              selectedBot.pageid
            )) &&
            user.tickets &&
            user.tickets.length > 0 &&
            user.hasOwnProperty('tickets') &&
            !isRatchthani)
        "
      >
        <v-layout row wrap class="ma-0">
          <v-flex xs7>
            <div class="caption pt-2 pl-2" style="word-break: break-all">
              <div v-if="isAiraAifulPage">
                <v-layout row wrap class="ma-0">
                  <v-flex>
                    <a
                      style="color: grey"
                      href="javascript:void(0);"
                      @click="isEditAssigned = true"
                    >
                      <v-icon small class="mr-1">person</v-icon>
                      <span>{{ user.tickets[0][1] }}</span>
                    </a>
                  </v-flex>
                  <edit-ticket
                    v-model="user"
                    :loading="false"
                    :livechat="true"
                    :is-edit-assigned="isEditAssigned"
                    @editTicket="onEditTicket"
                    @onCancelAssgined="cancelAssign"
                  ></edit-ticket>
                </v-layout>
              </div>
              <div v-else><v-icon small class="mr-1">person</v-icon>{{ user.tickets[0][1] }}</div>
            </div>
          </v-flex>
          <v-flex xs5 class="text-xs-right">
            <!-- Ticket Status -->
            <div>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-chip
                    small
                    :color="ticketColorStatus(user.tickets[0][2])"
                    dark
                    class="caption"
                    alt="Ticket Status"
                    @click="showEditTicket2Status"
                    v-on="on"
                  >
                    {{ user.tickets[0][2] }} <v-icon small class="ml-1"> arrow_drop_down</v-icon>
                  </v-chip>
                </template>
                <span>Ticket Status</span>
              </v-tooltip>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <div v-if="selectedBot.theme === 'seagull'">
      <div>
        <v-layout row wrap class="ma-0" justify-end>
          <v-flex xs5 class="text-xs-right">
            <!-- Ticket Status -->
            <div>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-chip
                    small
                    :color="ticketColorStatus(user.ticket.status)"
                    dark
                    class="caption"
                    alt="Ticket Status"
                    @click.stop="showEditTicketStatus"
                    v-on="on"
                  >
                    {{ user.ticket.status }} <v-icon small class="ml-1"> arrow_drop_down</v-icon>
                  </v-chip>
                </template>
                <span>Ticket Status</span>
              </v-tooltip>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div v-if="['dtac-gaming'].includes(selectedBot.type) && user.tags">
      <v-layout wrap>
        <v-flex xs12 class="text-xs-right">
          <template v-if="formattedTags(user.tags).length > 1">
            <template v-for="(tag, index) in formattedTags(user.tags)">
              <v-chip :key="index" small color="primary" dark class="caption">{{ tag }}</v-chip>
            </template>
          </template>
          <template v-else>
            <v-chip small color="primary" dark class="caption">{{ user.tags }}</v-chip>
          </template>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="['root'].includes(selectedBot.type) && user.company_name">
      <v-layout wrap>
        <v-flex xs12 class="text-xs-right">
          <v-chip small color="primary" dark class="caption" style="max-width: 100%">{{
            user.company_name
          }}</v-chip>
        </v-flex>
      </v-layout>
    </div>
    <div
      v-if="['summitcapital', 'toa'].includes($store.state.livechat.theme) && user.assignadmin_id"
      class="text-xs-right"
    >
      <v-chip small color="primary" dark class="caption">{{ user.assignadmin_id }}</v-chip>
    </div>
    <div v-if="$store.state.kfcpage.includes(selectedBot.pageid)" class="caption pt-2 pl-2">
      {{ user.temp_msg }}
    </div>

    <div v-if="['nongtungjai'].includes(selectedBot.type) && user.status" class="text-xs-right">
      <v-chip small color="primary" dark class="caption">{{ user.status }}</v-chip>
    </div>
    <div
      v-if="
        (currentTheme == 'ticket' ||
          [...$store.state.ticketThemeList].includes(selectedBot.theme) ||
          $store.state.ticketPageid.includes(selectedBot.pageid)) &&
        ![...$store.state.oceanlifePage].includes(selectedBot.pageid) &&
        !['nt'].includes(selectedBot.type) &&
        user.status
      "
      class="text-xs-right"
      :style="'position: block; right: 0px; bottom: 0px'"
    >
      <template v-if="[...$store.state.bbqPage].includes(selectedBot.pageid)">
        <v-chip
          v-if="user.status"
          small
          :color="handleBbqGetStatusColor(user.status)"
          dark
          class="caption"
          >{{ user.status }}</v-chip
        >
      </template>
      <template v-else>
        <v-chip v-if="user.status == 'cancelled'" small color="error" dark class="caption">{{
          user.status
        }}</v-chip>
        <v-chip v-else-if="user.status == 'closed'" small color="grey" dark class="caption">{{
          user.status
        }}</v-chip>
        <v-chip v-else-if="user.status == 'pendding'" small color="warning" dark class="caption">{{
          user.status
        }}</v-chip>
        <v-chip v-else small color="primary" dark class="caption">{{ user.status }}</v-chip>
      </template>
    </div>
    <div>
      <v-dialog
        v-model="ticket2Modal"
        content-class="nooverflow"
        class="dialog-nooverflow"
        width="400px"
        persistent
        style="overflow-y: none !important"
      >
        <v-card class="pa-3">
          <div class="mb-3" style="font-size: 21px; font-weight: 600">Change status</div>
          <div>
            <multiselect
              v-model="input.ticket2status"
              tag-placeholder="Add this as new tag"
              placeholder="Status"
              :searchable="false"
              :options="optionsStatus"
              :show-labels="false"
            ></multiselect>
          </div>
          <div class="text-xs-center mt-2">
            <v-btn outline color="grey" @click="ticket2Modal = false">Cancel</v-btn>
            <v-btn :loading="saveloading" depressed color="primary" @click="saveTicket2Status"
              >Save</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="ticketModal"
        content-class="nooverflow"
        class="dialog-nooverflow"
        width="400px"
        persistent
        style="overflow-y: none !important"
      >
        <v-card class="pa-3">
          <div class="mb-3" style="font-size: 21px; font-weight: 600">Change status</div>
          <div>
            <multiselect
              v-model="ticketstatus"
              tag-placeholder="Add this as new tag"
              placeholder="Status"
              :searchable="false"
              :options="renderOptionStatus"
              :show-labels="false"
            ></multiselect>
          </div>
          <div class="text-xs-center mt-2">
            <v-btn outline color="grey" @click="ticketModal = false">Cancel</v-btn>
            <v-btn :loading="saveloading" depressed color="primary" @click="saveTicketStatus"
              >Save</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import api from '@/api'
import { PAGE } from '@/constants/page.js'
import EditTicket from '../template/ticket/EditTicketLiveChat'
import LivechatUserItemTicket from './livechat-user-item-ticket.vue'
import LivechatUserItemTags from './livechat-user-item-tags.vue'
import chatlogApi from '@/api/chatlog'

export default {
  components: {
    Multiselect,
    EditTicket,
    LivechatUserItemTicket,
    LivechatUserItemTags
  },
  filters: {
    time: function (date) {
      if (typeof date === 'string') {
        date = moment(date)
      }
      return date.format('h:mm A')
    },
    fmMessage(value) {
      if (value && (value.startsWith('data:image') || value.includes('\\"image_url\\"'))) {
        return 'image'
      } else if (value && value.indexOf('talk_to_human') > 0) {
        const objectMessage = JSON.parse(value)
        return objectMessage.data.displayText
      } else {
        return value
      }
    }
  },
  props: ['value', 'selected'],
  data: function () {
    return {
      user: {},
      saveloading: false,
      input: {
        ticket2status: ''
      },
      ticketstatus: null,
      ticketModal: false,
      hasNewMessage: false,
      ticket2Modal: false,
      optionsStatus: ['Pending', 'Answered', 'Cancel', 'Closed'],
      isEditAssigned: false
    }
  },

  computed: {
    ...mapGetters(['selectedBot', 'livechat']),
    renderOptionStatus() {
      let output = []
      switch (this.selectedBot.theme) {
        case 'seagull':
          output = ['Closed']
          break
        default:
          output = this.optionsStatus
          break
      }
      return output
    },
    privilege() {
      return this.$store.state.privilege
    },
    pinUser() {
      let privilege = this.privilege
      if (this.user.app == 'facebook' && privilege && privilege.pinUserFacebook) {
        return privilege.pinUserFacebook.split(',')
      } else if (this.user.app == 'line' && privilege && privilege.pinUserLine) {
        return privilege.pinUserLine.split(',')
      } else {
        return []
      }
    },
    userLastReplyTime() {
      return moment(this.user.lastreply_time).format('DD MMM YYYY HH:mm')
    },
    currentTheme() {
      return this.$store.state.livechat.theme
        ? this.$store.state.livechat.theme
        : this.selectedBot.theme
    },
    userRealname: {
      get() {
        if (this.value && this.value.realname) {
          return this.value.realname
        } else
          return (
            (this.value.first_name ? this.value.first_name : '') +
            (this.value.last_name ? ' ' + this.value.last_name : '')
          )
      },
      set(val) {
        this.value.realname
      }
    },
    chatConfig() {
      return this.$store.state.chatConfig
    },
    customBackgroudStyle() {
      let bgStyle = ''
      if (this.$store.state.kfcpage.includes(this.selectedBot.pageid)) {
        if (this.user.status == 'ลูกค้ารอ') {
          bgStyle = { backgroundColor: 'rgb(211 255 206) !important' }
        } else if (this.user.status == 'ตอบแล้ว') {
          bgStyle = { backgroundColor: 'rgb(255 220 220) !important' }
        }
      } else if (['cityfresh'].includes(this.selectedBot.theme)) {
        if (this.user && this.user.adminread) {
          bgStyle = { color: '#000 !important' }
        } else {
          bgStyle = { backgroundColor: '#C3D9A7 !important', color: '#000 !important' }
        }
      } else if (this.isAiraAifulPage) {
        if (
          this.user.context === 'contactadmin' &&
          this.user.tickets[0][2] === 'answered' &&
          !this.user.adminread
        ) {
          bgStyle = { backgroundColor: '#BEBEBE !important', color: '#FFF !important' }
        }
      } else if (['nt'].includes(this.selectedBot.type)) {
        if (this.user && this.user.adminread) {
          bgStyle = { backgroundColor: this.chatConfig.admin_read }
          // bgStyle = this.getTextColorByBgColor(this.chatConfig.admin_read)
        } else {
          bgStyle = { backgroundColor: this.chatConfig.admin_unread }
          // bgStyle = this.getTextColorByBgColor(this.chatConfig.admin_unread)
        }
      } else if (this.isRatchthani) {
        try {
          if (
            this.user.tickets &&
            this.user.tickets[0] &&
            this.user.tickets[0][25] &&
            this.user.tickets[0][25] === 'true'
          ) {
            bgStyle = { backgroundColor: '#EF9A9A !important', color: '#000 !important' }
          }
        } catch (error) {
          console.error(error)
        }
      }

      return bgStyle
    },
    textColorClass() {
      let className = ''
      if (['cityfresh', 'tisco'].includes(this.$store.state.livechat.theme)) {
        if (!this.user.adminread) {
          className = 'unreadmessage'
        } else {
          className = 'black--text'
        }
      } else if (this.isAiraAifulPage) {
        if (
          this.user.context === 'contactadmin' &&
          this.user.tickets[0][2] === 'answered' &&
          !this.user.adminread
        ) {
          className = 'white--text'
        } else {
          className = 'grey--text text--lighten-1'
        }
      } else if (this.isRatchthani) {
        try {
          if (
            this.user.tickets &&
            this.user.tickets[0] &&
            this.user.tickets[0][25] &&
            this.user.tickets[0][25] === 'true'
          ) {
            className = 'black--text'
          } else {
            className = 'grey--text text--lighten-1'
          }
        } catch (error) {
          console.error(error)
        }
      } else if (['nt'].includes(this.selectedBot.type)) {
        if (this.user.adminread) {
          const textClass = this.getTextColorByBgColor(this.chatConfig.admin_read)

          className = `${textClass}`
        } else {
          const textClass = this.getTextColorByBgColor(this.chatConfig.admin_unread)

          className = `${textClass} font-weight-bold`
        }
      } else {
        if (!this.user.adminread) {
          className = 'unreadmessage'
        } else {
          className = 'grey--text text--lighten-1'
        }
      }
      return className
    },
    isAiraAifulPage() {
      return PAGE.AIRA_AIFUL.includes(this.selectedBot.pageid)
    },
    isRatchthani() {
      return PAGE.RATCHTHANI.includes(this.selectedBot.pageid)
    },
    isJuzmatch() {
      return [...PAGE.JUZMATCH_SALE, ...PAGE.JUZMATCH_CRM].includes(this.selectedBot.pageid)
    },
    page() {
      return PAGE
    },
    isShowTicketInfo() {
      return (
        ['nt'].includes(this.selectedBot.type) && this.user.tickets && this.user.tickets.length > 0
      )
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.user = newVal
      if (newVal.lastreply_time != oldVal.lastreply_time) {
        if (this.selected != true) {
          this.hasNewMessage = true
        }
      }
    }
  },
  async mounted() {
    if (this.value) {
      this.user = this.value
    }
  },

  methods: {
    handleUpdateTicketStatus(status) {
      this.user.tickets[0][2] = status
      const type = this.$store.state.livechat.type
      if (status.toLowerCase().includes('closed') && type === 'admin') {
        this.$store.dispatch('handleRemoveUserFromAdminTap', {
          user_id: this.user.userid,
          pageid: this.$store.state.livechat.pageid,
          type: type
        })
        this.$store.dispatch('handleUpdateLivechatUser', {
          user_id: this.user.userid,
          type,
          data: {
            context: ''
          }
        })
      }
    },
    async handleMenuMarkUnRead() {
      try {
        await chatlogApi.postMarkAsUnRead({
          page_id: this.livechat.pageid,
          user_id: this.user.userid
        })
        this.$swal({
          title: 'อัพเดทสำเร็จ',
          type: 'success',
          confirmButtonText: this.$t('Confirm')
        })
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
        await this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    async handleMenuBlock(is_block = true) {
      try {
        await chatlogApi.putBlockUser({
          page_id: this.livechat.pageid,
          user_id: this.user.userid,
          is_block
        })
        this.$swal({
          title: 'อัพเดทสำเร็จ',
          type: 'success',
          confirmButtonText: this.$t('Confirm')
        })
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
        await this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    async clickUnPin() {
      try {
        let tempPrivilege = this.$store.state.privilege ? this.$store.state.privilege : {}
        if (this.user.app == 'facebook' && tempPrivilege.pinUserFacebook) {
          tempPrivilege.pinUserFacebook = tempPrivilege.pinUserFacebook.split(',')
          if (
            tempPrivilege.pinUserFacebook.length == 1 &&
            tempPrivilege.pinUserFacebook[0] == this.user.userid
          ) {
            delete tempPrivilege.pinUserFacebook
          } else {
            const index = tempPrivilege.pinUserFacebook.indexOf(this.user.userid)
            if (index > -1) {
              tempPrivilege.pinUserFacebook.splice(index, 1)
            }
            tempPrivilege.pinUserFacebook = tempPrivilege.pinUserFacebook
              ? tempPrivilege.pinUserFacebook.join(',')
              : ''
          }
        } else if (this.user.app == 'line' && tempPrivilege.pinUserLine) {
          tempPrivilege.pinUserLine = tempPrivilege.pinUserLine.split(',')
          if (
            tempPrivilege.pinUserLine.length == 1 &&
            tempPrivilege.pinUserLine[0] == this.user.userid
          ) {
            delete tempPrivilege.pinUserLine
          } else {
            const index = tempPrivilege.pinUserLine.indexOf(this.user.userid)
            if (index > -1) {
              tempPrivilege.pinUserLine.splice(index, 1)
            }
            tempPrivilege.pinUserLine = tempPrivilege.pinUserLine
              ? tempPrivilege.pinUserLine.join(',')
              : ''
          }
        }
        this.fetchChangeprivilegeadminuser(tempPrivilege)
      } catch (error) {
        console.error(error)
      }
    },
    async clickPin() {
      try {
        let tempPrivilege = this.$store.state.privilege ? this.$store.state.privilege : {}
        if (this.user.app == 'facebook') {
          if (tempPrivilege.pinUserFacebook && tempPrivilege.pinUserFacebook.length) {
            tempPrivilege.pinUserFacebook = tempPrivilege.pinUserFacebook + `,${this.user.userid}`
          } else {
            tempPrivilege = {
              ...tempPrivilege,
              pinUserFacebook: this.user.userid
            }
          }
        } else if (this.user.app == 'line') {
          if (tempPrivilege.pinUserLine && tempPrivilege.pinUserLine.length) {
            tempPrivilege.pinUserLine = tempPrivilege.pinUserLine + `,${this.user.userid}`
          } else {
            tempPrivilege = {
              ...tempPrivilege,
              pinUserLine: this.user.userid
            }
          }
        }
        this.fetchChangeprivilegeadminuser(tempPrivilege)
      } catch (error) {
        console.error(error)
      }
    },
    async fetchChangeprivilegeadminuser(tempPrivilege) {
      let vm = this
      try {
        const body = {
          userid: this.$store.state.userid,
          pageid: this.selectedBot.pageid,
          privilege: JSON.stringify(tempPrivilege)
        }
        await api.changeprivilegeadminuser({ data: body }, (error, response) => {
          if (error) {
            console.error(error)
          }
          if (response.responsecode && response.responsecode == 200) {
            vm.$store.dispatch('savePrivilege', JSON.stringify(tempPrivilege))
          }
          return true
        })
      } catch (error) {
        console.error(error)
      }
    },
    getTextColorByBgColor(color) {
      const bgColor = color

      let r, g, b

      if (bgColor.match(/^rgb/)) {
        const tempColor = bgColor.match(
          /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        )
        r = tempColor[1]
        g = tempColor[2]
        b = tempColor[3]
      } else {
        r = parseInt(bgColor.slice(1, 3), 16)
        g = parseInt(bgColor.slice(3, 5), 16)
        b = parseInt(bgColor.slice(5, 7), 16)
      }

      const hsp = r * 0.299 + g * 0.587 + b * 0.114

      let textClass = ''
      if (hsp > 127.5) {
        textClass = 'black--text'
      } else {
        textClass = 'white--text'
      }

      return textClass
    },
    checkOldCase(dateTime) {
      const now = moment()
      dateTime = moment(dateTime)
      const diffData = now.diff(dateTime, 'hour')
      return diffData >= 1
    },
    onEditTicket(data) {
      const tmpUpdateTickets = [
        data.id,
        data.assignadminid,
        data.status,
        data.details,
        data.assigngroupid,
        data.assignsubgroupid,
        data.channel,
        data.updateadminid,
        data.priority,
        data.duedate,
        data.tags,
        data.contact_firstname,
        data.contact_lastname,
        data.contact_salary,
        data.contact_occupation,
        data.contact_phone,
        data.contact_email,
        data.orderid,
        data.satisfaction_score,
        data.recommendation_score,
        data.suggestion_note
      ]
      this.user.tickets = [tmpUpdateTickets]
      this.isEditAssigned = false
      this.$emit('editTicketSuccess')
    },
    cancelAssign() {
      this.isEditAssigned = false
    },
    saveTicket2Status() {
      var data = {
        pageid: this.$store.state.livechat.pageid,
        status: this.input.ticket2status.toLowerCase(),
        ticketId: this.user.tickets[0][0]
      }
      this.saveloading = true
      api.ticket2UpdateTicket(data, (err, response) => {
        this.saveloading = false
        this.user.tickets[0][2] = this.input.ticket2status
        this.ticket2Modal = false
      })
    },
    saveTicketStatus() {
      const vm = this
      const ticketId = vm.user.ticket.id
      var data = {
        pageid: vm.$store.state.livechat.pageid,
        status: vm.input.ticket2status.toLowerCase() || vm.ticketstatus.toLowerCase(),
        ticketId
      }
      vm.saveloading = true
      api.ticket2UpdateTicket(data, (err, response) => {
        vm.saveloading = false
        vm.user.ticket.status = vm.ticketstatus
        vm.ticketModal = false
      })
    },
    showEditTicket2Status() {
      this.input.ticket2status = this.user.tickets[0][2]
      this.ticket2Modal = true
    },
    showEditTicketStatus() {
      this.ticketstatus = this.user.ticket.status
      this.ticketModal = true
    },
    ticketColorStatus(val) {
      switch (val.trim().toLowerCase()) {
        case 'pending':
          return '#fb8c00'
        case 'closed':
          return '#e0e0e0'
        case 'cancelled':
          return '#ff5252'
        case 'cancelled by customer':
          return '#fd87ee'
        case 'answered':
          return '#2196f3'
        case 'open':
          return '#4CAF50'
        case 'success':
          return '#e0e0e0'
        default:
          return ''
      }
    },

    handleBbqGetStatusColor(status) {
      const bbqStatusColor = this.$store.state.bbqStatusColor
      const filterStatus = bbqStatusColor
        ? bbqStatusColor.find((el) => {
            return el.status === status
          })
        : undefined

      return filterStatus ? filterStatus.color : 'primary'
    },
    imgError: function (event, el) {
      // console.log('not load')
      this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    },
    dayLeft: function (replytime) {
      let lastreply = moment(replytime)
      let currentDate = moment()

      let time = ''
      if ([...this.$store.state.bbqPage].includes(this.selectedBot.pageid)) {
        time = lastreply.format('DD MMM YYYY HH:mm')
      } else {
        if (currentDate.diff(lastreply, 'days') > 0) {
          time = lastreply.format('DD MMM YYYY')
        } else if (currentDate.diff(lastreply, 'hours') > 0) {
          time = currentDate.diff(lastreply, 'hours')
          time += ' ' + this.$t('Hours')
        } else if (currentDate.diff(lastreply, 'minutes') > 0) {
          time = currentDate.diff(lastreply, 'minutes')
          time += ' ' + this.$t('Minutes')
        } else if (currentDate.diff(lastreply, 'seconds') > 0) {
          time = currentDate.diff(lastreply, 'seconds')
          time += ' ' + this.$t('Seconds')
        }
      }

      // if (['summitcapital'].includes(this.$store.state.livechat.theme)) {
      //   const tempTime = `${time} ${lastreply.format('DD MMM YYYY HH:mm')}`
      //   time = tempTime
      // }
      return time
    },
    formattedTags(tags) {
      let tempTags = []
      if (tags) {
        tempTags = tags.split(',')
      }
      return tempTags
    }
  }
}
</script>

<style lang="scss">
.px-0 .v-list__tile {
  padding-left: 5px !important;
  padding-right: 2px !important;
}
.unreadmessage {
  color: black !important;
  font-weight: bold;
}
.dark-style {
  .v-list__tile__title {
    color: #000 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-user-item.vue